<template>
  <el-dialog
    :title="isEdit ? '编辑学员' : '添加学员'"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <el-form
      ref="studentForm"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="学员姓名" prop="real_name">
        <el-input
          v-model="formData.real_name"
          placeholder="请输入学员姓名"
          maxlength="20"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="手机号" prop="mobile">
        <el-input
          v-model="formData.mobile"
          placeholder="请输入手机号"
          maxlength="11"
        />
      </el-form-item>

      <el-form-item label="用户名" prop="username" v-if="!isEdit">
        <el-input
          v-model="formData.username"
          placeholder="请输入用户名（用于登录）"
          maxlength="20"
        />
      </el-form-item>

      <el-form-item label="密码" prop="password" v-if="!isEdit">
        <el-input
          v-model="formData.password"
          type="password"
          placeholder="请输入密码"
          maxlength="20"
          show-password
        />
      </el-form-item>

      <el-form-item label="年级" prop="grade">
        <el-select
          v-model="formData.grade"
          placeholder="请选择年级"
          style="width: 100%"
        >
          <el-option label="小学一年级" value="小学一年级" />
          <el-option label="小学二年级" value="小学二年级" />
          <el-option label="小学三年级" value="小学三年级" />
          <el-option label="小学四年级" value="小学四年级" />
          <el-option label="小学五年级" value="小学五年级" />
          <el-option label="小学六年级" value="小学六年级" />
          <el-option label="初中一年级" value="初中一年级" />
          <el-option label="初中二年级" value="初中二年级" />
          <el-option label="初中三年级" value="初中三年级" />
          <el-option label="高中一年级" value="高中一年级" />
          <el-option label="高中二年级" value="高中二年级" />
          <el-option label="高中三年级" value="高中三年级" />
        </el-select>
      </el-form-item>

      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="formData.gender">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="0">女</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="家长姓名" prop="parentName">
        <el-input
          v-model="formData.parentName"
          placeholder="请输入家长姓名"
          maxlength="20"
        />
      </el-form-item>

      <el-form-item label="家长手机" prop="parentPhone">
        <el-input
          v-model="formData.parentPhone"
          placeholder="请输入家长手机号"
          maxlength="11"
        />
      </el-form-item> -->

      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio label="normal">在学</el-radio>
          <el-radio label="inactive">停课</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="备注">
        <el-input
          v-model="formData.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注信息"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'StudentFormDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    studentData: {
      type: Object,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };

    return {
      submitting: false,
      formData: {
        real_name: '',
        mobile: '',
        username: '',
        password: '',
        grade: '',
        gender: 1,
        parentName: '',
        parentPhone: '',
        status: 'normal',
        remark: '',
      },
      formRules: {
        real_name: [
          { required: true, message: '请输入学员姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' },
        ],
        mobile: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]+$/, message: '只能包含字母、数字和下划线', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
        ],
        grade: [{ required: true, message: '请选择年级', trigger: 'change' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        parentPhone: [{ validator: validatePhone, trigger: 'blur' }],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  methods: {
    ...mapActions('student', ['addStudent', 'updateStudent']),

    /**
     * 对话框打开时
     */
    handleOpen() {
      if (this.isEdit && this.studentData) {
        // 编辑模式，填充数据
        this.formData = { ...this.studentData };
      } else {
        // 添加模式，重置表单
        this.resetForm();
      }
    },

    /**
     * 关闭对话框
     */
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.formData = {
        real_name: '',
        mobile: '',
        username: '',
        password: '',
        grade: '',
        gender: 1,
        parentName: '',
        parentPhone: '',
        status: 'normal',
        remark: '',
      };
      this.$nextTick(() => {
        if (this.$refs.studentForm) {
          this.$refs.studentForm.clearValidate();
        }
      });
    },

    /**
     * 提交表单
     */
    handleSubmit() {
      this.$refs.studentForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }

        this.submitting = true;
        try {
          if (this.isEdit) {
            // 编辑学员
            await this.updateStudent({
              id: this.formData.id,
              ...this.formData,
            });
            this.$message.success('编辑学员成功');
          } else {
            // 添加学员
            await this.addStudent(this.formData);
            this.$message.success('添加学员成功');
          }
          this.$emit('success');
          this.handleClose();
        } catch (error) {
          console.error('提交失败:', error);
          const defaultMsg = this.isEdit ? '编辑学员失败' : '添加学员失败';
          this.$message.error(error.message || defaultMsg);
        } finally {
          this.submitting = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
